import TwoForOneHero from './TwoForOneHero'

export default TwoForOneHero
